import React from "react";
import { OriginatingTransactionClass } from "../../../../types/amr-pipeline/models/OriginatingTransactionClass";
import { AmrClass } from "../../../../types/amr-pipeline/models/AmrClass";
import { classesColumns } from './columns/classesColumns';
import { PipelineList } from "../PipelineList";
import { PipelineView } from "../../types/PipelineView";
import { UserConfigColumn } from "../../../../types/user-config/UserConfigColumn";
import { PipelineEmptyPlaceholder } from '../PipelineEmptyPlaceholder';
import { user } from "../../../../user";
import { roles } from "../../../../constants";
import classNames from "classnames";

interface Props {
    columnsConfig: UserConfigColumn[];
    classes: (OriginatingTransactionClass | AmrClass)[];
    onRedirect: () => void;
}

export const ClassView = ({ columnsConfig, classes, onRedirect }: Props) => {
    const isButtonAvailable = user.hasRoles(
        ...roles.getAllRolesExclude(
            ...roles.admin(),
            roles.DataEntry,
            roles.Viewer,
            roles.Media,
        )
    );
    
    return classes.length
        ? <PipelineList
            className={classNames('pipeline-list-class', { 'pipeline-list-class-with-button': isButtonAvailable })}
            dataItems={classes}
            columns={classesColumns(columnsConfig)}
            view={PipelineView.Class}
        />
        : <PipelineEmptyPlaceholder onRedirect={onRedirect} />
}
